import { AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { filter } from 'rxjs/operators';
import { UsersTypes } from 'src/app/_enums';
import { School, SystemUserType } from 'src/app/_models';

import { BaseComponent } from '../../../_base/base.component';
import { LanguageService } from '../../../_services';
import { MainService } from '../service/main.service';

declare var $;
@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MainComponent extends BaseComponent implements OnInit, AfterViewInit {
  // companyId
  schools: School[] = [];
  callNumber: number = 0;
  menuIsOpen: boolean = false;
  appIsOpen: boolean = false;
  currentUser: any;
  UserTypes = UsersTypes;
  @ViewChild('appCollapse')
  appCollapse;
  @ViewChild('menuModal')
  menuModal: BsModalRef;
  currentUserTypes: SystemUserType[] = [];
  selectedUserTypeId: number;
  configurations: PerfectScrollbarConfigInterface = {
    suppressScrollX: true,
    suppressScrollY: false
  };

  constructor(public router: Router, public translate: TranslateService, public data: MainService, public lang: LanguageService) {
    super();
  }

  ngOnInit() {
    this.menuInit();
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
      this.fixPageHeight();
    });
    this.fixPageHeight();
  }

  fixPageHeight() {
    $(document).ready(function() {
      setTimeout(() => {
        //// fix container height in all pages
        let ele = $('app-body > div')[0];
        if (ele) {
          $(ele).css('min-height', window.innerHeight - 190 + 'px');
          window.onresize = function(event) {
            ele = $('app-body > div');
            $(ele).css('min-height', window.innerHeight - 190 + 'px');
          };
        } else if (this.callNumber < 10) {
          this.fixPageHeight();
          this.callNumber = this.callNumber + 1;
        }
      }, 100);
    });
  }

  ngAfterViewInit() {
    this.menuInit();
  }
  menuInit(): void {
    this.data.menuInit();
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));

    if (!localStorage.getItem('CurrentPage')) {
      if (this.router.url !== '/' + this.data.menuList.Menu[0].RouteName) {
        this.router.navigate([this.data.menuList.Menu[0].RouteName]);
      }
      this.data.menuList.ActivePage = 0;
      this.data.menuList.ActiveNested = 0;
      this.data.menuList.ActivePageSecond = -1;
      this.data.menuList.ActivePageThird = -1;
      localStorage.setItem('CurrentPage', JSON.stringify([0, -1, -1]));
    } else {
      this.data.menuList.ActiveNested = JSON.parse(localStorage.getItem('CurrentPage'))[0];
      this.data.menuList.ActivePage = JSON.parse(localStorage.getItem('CurrentPage'))[0];
      this.data.menuList.ActivePageSecond = JSON.parse(localStorage.getItem('CurrentPage'))[1];
      this.data.menuList.ActivePageThird = JSON.parse(localStorage.getItem('CurrentPage'))[2];
      this.data.menuList.Menu[this.data.menuList.ActivePage].IsOpen = true;
      this.data.menuList.Menu[this.data.menuList.ActivePage].SecondPageIndex = this.data.menuList.ActivePageSecond;
    }
  }
  menuStatus(type: string): void {
    this.menuIsOpen = type === 'onShow';
  }

  toggle(index: number): void {
    if (index === 1 && !this.appIsOpen) this.appIsOpen = true;
  }

  goTo(index: number, childIndex: number) {
    if (childIndex !== -1) {
      if (!this.data.menuList.Menu[index].Menu[childIndex].IsNested && !this.data.menuList.Menu[index].Menu[childIndex].disabled) {
        this.data.menuList.ActivePage = index;
        this.data.menuList.ActivePageSecond = childIndex;
        this.data.menuList.Menu[index].SecondPageIndex = childIndex;
        this.data.menuList.ActivePageThird = -1;
        localStorage.setItem('CurrentPage', JSON.stringify([index, childIndex, -1]));
        this.router.navigate([this.data.menuList.Menu[index].Menu[childIndex].RouteName]);
        this.menuModal.hide();
      }
    } else if (!this.data.menuList.Menu[index].IsNested) {
      if (!this.data.menuList.Menu[index].disabled) {
        this.data.menuList.ActivePage = index;
        this.data.menuList.ActivePageSecond = -1;
        this.data.menuList.ActivePageThird = -1;
        if (this.data.menuList.ActiveNested >= 0) {
          if (this.data.menuList.Menu[this.data.menuList.ActiveNested].IsOpen) {
            this.data.menuList.Menu[this.data.menuList.ActiveNested].IsOpen = false;
            this.data.menuList.ActiveNested = index;
          }
        }
        localStorage.setItem('CurrentPage', JSON.stringify([index, -1, -1]));
        this.router.navigate([this.data.menuList.Menu[index].RouteName]);
        this.menuModal.hide();
      }
    } else {
      if (this.data.menuList.ActiveNested !== index) {
        this.data.menuList.Menu[this.data.menuList.ActiveNested].IsOpen = false;
      }
      if (this.data.menuList.ActivePage === index) {
        this.data.menuList.ActivePageSecond = this.data.menuList.Menu[index].SecondPageIndex;
        this.data.menuList.ActivePageThird = this.data.menuList.Menu[index].ThirdPageIndex;
      } else {
        this.data.menuList.ActivePageSecond = -1;
        this.data.menuList.ActivePageThird = -1;
      }
      this.data.menuList.Menu[index].IsOpen = !this.data.menuList.Menu[index].IsOpen;
      if (this.data.menuList.Menu[index].IsOpen) {
        this.data.menuList.ActiveNested = index;
      } else {
        this.data.menuList.ActiveNested = 0;
      }
    }
  }

  trackBy(item: any): number {
    return item.id;
  }

  closeMenu(target) {
    if ($('.collapse_' + target + '+ .collapse.show').length > 0) {
      $('.collapse_' + target).click();
    }
  }
  route() {
    if (this.currentUser.userType !== this.UserTypes.Teacher) this.router.navigate(['Home/SystemSettings/SchoolSettings']);
  }
}
